import { render, staticRenderFns } from "./ClimateRisksChart.vue?vue&type=template&id=5fdf7f02&scoped=true"
import script from "./ClimateRisksChart.vue?vue&type=script&lang=ts"
export * from "./ClimateRisksChart.vue?vue&type=script&lang=ts"
import style0 from "./ClimateRisksChart.vue?vue&type=style&index=0&id=5fdf7f02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdf7f02",
  null
  
)

export default component.exports